import { H1, P } from "@/components/ui";
import React, { FC, ReactNode } from "react";

type Heading1Props = {
  title?: ReactNode;
  subtitle?: ReactNode;
  titleClassName?: string;
  subtitleClassName?: string;
};

export const Heading1: FC<Heading1Props> = ({
  title = "",
  subtitle = "",
  titleClassName = "",
  subtitleClassName = "",
}) => {
  return (
    <>
      <H1 className={titleClassName}>{title}</H1>
      <P className={subtitleClassName}>{subtitle}</P>
    </>
  );
};
